/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Attribution_HtmlInputs */



/**

* @param {Footer_Attribution_HtmlInputs} inputs
* @param {{ locale?: "es" }} options
* @returns {LocalizedString}
*/
export const footer_attribution_html = /** @type {((inputs?: Footer_Attribution_HtmlInputs, options?: { locale?: "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Attribution_HtmlInputs, { locale?: "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Basado en el contenido de <a href=\"https://pauseai.info\" target=\"_blank\" rel=\"noopener noreferrer\">PauseAI.info</a> y su <a href=\"https://github.com/PauseAI/pauseai-website\" target=\"_blank\" rel=\"noopener noreferrer\">repositorio original</a>, creado por la comunidad PauseAI. Esta versión en español añade adaptación y traducción locales. Licencia <a href=\"https://creativecommons.org/licenses/by/4.0/\" target=\"_blank\" rel=\"noopener noreferrer\">CC BY 4.0</a>.")
});